import React, { useEffect, useState } from 'react';
import Dialog from "../Dialog/Dialog";
import Autocomplete from "../Autocomplete/Autocomplete";

import './ExportsDialog.css';

export default function ExportDialog({
  open,
  onClose,
  services,
  tableOptions,
  entityLabel,
}) {
  const [formatType, setFormatType] = useState('');
  const [isExporting, setIsExporting] = useState(false);

  const formats = ['.csv', '.xlsx', '.json', '.txt', '.zip'];

  // Close on Escape key
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);
  
  // Load XLSX dynamically (like Vue mounted())
  useEffect(() => {
    if (!window.XLSX) {
      const script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.17.0/xlsx.full.min.js';
      script.async = true;
      document.head.appendChild(script);
    }
  }, []);

  
  const closeDialog = () => {
    setFormatType('');
    onClose();
  };

  /* ---------- DOWNLOAD HELPERS ---------- */

  const downloadBlob = (blob, filename) => {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link);
  };

  const convertToCSV = (data) => {
    if (!data.length) return '';
    const headers = Object.keys(data[0]);
    const rows = [
      headers.join(','),
      ...data.map(row =>
        headers.map(h => `"${String(row[h] ?? '').replace(/"/g, '""')}"`).join(',')
      ),
    ];
    return rows.join('\n');
  };

  /* ---------- EXPORT ---------- */

  const exportFile = async () => {
    if (!formatType) return;

    setIsExporting(true);
    
    try {
      let params= {
            tableOptions,
            formatType,
          };
      if (formatType !== '.zip') {
        const res = await services.export({
          params,
        }, services.services_url_names.export);
        //data=data.data
        if (formatType === '.csv') {
          const csv = convertToCSV(res.data);
          downloadBlob(new Blob([csv]), 'parameters_export.csv');
        } else if (formatType === '.xlsx') {
          const wb = window.XLSX.utils.book_new();
          const ws = window.XLSX.utils.json_to_sheet(res.data);
          window.XLSX.utils.book_append_sheet(wb, ws, 'Parameters');
          const wbout = window.XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
          downloadBlob(new Blob([wbout]), 'parameters_export.xlsx');
        } else {
          downloadBlob(
            new Blob([JSON.stringify(res.data, null, 2)]),
            `parameters_export${formatType}`
          );
        }
      } else {

        const res = await services.export_bilan(params, services.services_url_names.export_bilan);

        downloadBlob(
          new Blob([res.data], { type: 'application/zip' }),
          'parameters_export.zip'
        );
      }
    } catch (err) {
      console.error(err);
      alert('Export failed');
    } finally {
      setIsExporting(false);
    }
  };

  return (
      <Dialog open={open} onClose={onClose}>
            
        <h2>Export {entityLabel}</h2>

        <Autocomplete
          mode="select"             // or "select" if you want it non-editable
          value={formatType}
          onChange={setFormatType}
          placeholder="Select file type"
          options={formats.map(f => ({ label: f, value: f }))}
        />



        <div style={{ marginTop: 16 }}>
          <button className="label-btn" style={{ "--label-btn-color": "#43A047" }}
            disabled={!formatType || isExporting}
            onClick={exportFile}
          >
            {isExporting ? 'Exporting...' : 'EXPORT'}
          </button>

          <button className="label-btn" style={{ "--label-btn-color": "#43A047", "margin-left": "8" }} onClick={closeDialog} >
            Close
          </button>
        </div>
      </Dialog>
  );
}
